// Sidebar.jsx (Refatorado)
import { ChevronDown, ChevronRight } from "lucide-react";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import Icon from "~/components/Icon";
import OpenClose from "~/components/Sidebar/OpenClose";
import SidebarItem from "~/components/SidebarItem";

export default function Sidebar({ main = null, pages = [] }) {
  const [oppened, setOppened] = useState(true);
  const { pathname } = useLocation();
  const isPageActive = (page) => pathname.toLowerCase() === page.path.toLowerCase() || pathname.toLowerCase().startsWith(page.path.toLowerCase() + "/");
  const { accesses } = useSelector((state) => state.auth);

  const activeMenu = {
    class:
      "p-2 bg-mila_orange transition ease-out delay-100 duration-300 rounded-sm flex flex-row justify-center items-center cursor-pointer text-xs text-white gap-2",
    color: "#FFF",
  };

  const inactiveMenu = {
    class:
      "p-2 bg-transparent rounded-sm flex flex-row hover:bg-gray-300 justify-center items-center cursor-pointer text-xs gap-2 text-gray-500",
  };

  const hasAccess = (page) => {
    const mainAccess = accesses.hierarchy.find(
      (h) => h.alias?.toUpperCase() === main?.toUpperCase()
    );
    if (!mainAccess) return false;
    return mainAccess.children?.some(
      (h) => h.alias?.toUpperCase() === page?.alias?.toUpperCase()
    );
  };

  const hasChildAccess = (child, parent) => {
    if (!["messages", "financial-collections", "tickets"].includes(parent.alias)) return hasAccess(child);
    const mainAccess = accesses.hierarchy.find(
      (h) => h.alias?.toUpperCase() === main?.toUpperCase()
    );
    const messages = mainAccess?.children?.find((h) => h.alias === parent.alias);
    return messages?.children?.some(
      (h) => h.alias === child.alias && h.MenuHierarchyXGroup?.view
    );
  };

  return (
    <div
      className={`${
        oppened ? "min-w-[180px]" : "min-w-[70px]"
      } h-full bg-secondary flex flex-col justify-start items-start rounded-tl-2xl p-4 overflow-y-scroll`}
    >
      <OpenClose oppened={oppened} setOppened={setOppened} />

      <div
        className={`my-12 flex flex-1 flex-col justify-start items-start gap-4 w-full`}
      >
        {pages.filter(hasAccess).map((page, index) => (
          <div key={index} className="w-full">
            <SidebarItem
              page={{ ...page, isActive: isPageActive(page) }}
              oppened={oppened}
              activeMenu={activeMenu}
              inactiveMenu={inactiveMenu}
            />
            {isPageActive(page) && page.children && (
              <div className="flex flex-col w-full">
                {page.children.filter((child) => hasChildAccess(child, page)).map((child, childIndex) => (
                  <NavLink
                    key={childIndex}
                    to={child.path}
                    className="flex flex-row items-center justify-between rounded-md pl-4 w-full flex-1 py-2 text-sm font-medium text-gray-700 hover:text-gray-900"
                  >
                    {({ isActive }) => (
                      <div
                        className={`w-full border ${
                          isActive
                            ? "p-2 border-mila_orange transition ease-out delay-100 duration-300 rounded-sm flex flex-row justify-center items-center cursor-pointer text-xs gap-2"
                            : inactiveMenu.class
                        }`}
                      >
                        {child.icon && <Icon name={child.icon} size={16} />}
                        {oppened && (
                          <div
                            className={`flex-1 ${
                              isActive ? "text-mila_orange" : "text-gray-500"
                            }`}
                          >
                            {child.title}
                          </div>
                        )}
                      </div>
                    )}
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
